import { service } from "swift-frame";
import axios from 'axios';
const { apiPost } = service;
export const SHORTURL = process.env.VUE_APP_API || window.location.origin;

//短链接创建接口
export const createShortLink = (data) => apiPost(SHORTURL + "/web/shortUrlCreateService", data);
//短链接项目列表接口
export const getShortUrlProjectList = (data) => apiPost(SHORTURL + "/web/shortUrlProjectListService", data);

//获取短链接信息
export const getShorturlInfo = (data) => apiPost(SHORTURL + "/web/getShorturlInfo", data);
//手机号校验
export const checkPhone = (data) => apiPost(SHORTURL + "/web/checkPhone", data);
//上传文件
export const uploadAction = (data) =>
  axios({
    url: SHORTURL + "/web/upload",
    method: 'post',
    data: data,
    headers: {
      'content-type': 'multipart/form-data',
    },
  });
